import React from "react";
import { Helmet } from "react-helmet";

/**
 * Technical SEO: LocalBusiness + AutomotiveBusiness + AutoRepair (schema.org).
 * Keep SITE_ORIGIN aligned with production canonical URLs.
 */
export const SITE_ORIGIN = "https://www.advancedautomotivesmog.com";

/** Stable identifier for the LocalBusiness entity — reference this from other JSON-LD (e.g. Service.provider) instead of re-declaring the business. */
export const BUSINESS_ID = `${SITE_ORIGIN}/#local-business`;

export function buildLocalBusinessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "AutomotiveBusiness", "AutoRepair"],
    "@id": BUSINESS_ID,
    name: "Advanced Automotive Smog",
    url: SITE_ORIGIN,
    telephone: "+19512961242",
    image: `${SITE_ORIGIN}/assets/home.jpeg`,
    description:
      "Smog check, emissions testing, diagnostics, and automotive repair in Temecula, California.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "42103 Rio Nedo, Ste 108",
      addressLocality: "Temecula",
      addressRegion: "CA",
      postalCode: "92590",
      addressCountry: "US",
    },
    openingHours: "Mo-Fr 08:30-17:30",
    sameAs: [
      "https://www.facebook.com/profile.php?id=61573424138548",
      "https://www.instagram.com/advautosmog/",
      "https://x.com/AdvAutoSmog",
      "https://www.linkedin.com/in/edgar-depaz-3ba172353/",
    ],
    areaServed: {
      "@type": "City",
      name: "Temecula",
      containedInPlace: {
        "@type": "State",
        name: "California",
      },
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Automotive services (summary)",
      itemListElement: [
        {
          "@type": "OfferCatalog",
          name: "Smog & emissions",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Smog check / emissions inspection",
              },
            },
          ],
        },
        {
          "@type": "OfferCatalog",
          name: "Repair & maintenance",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "General automotive diagnostics and repair",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Brake and suspension service",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Air conditioning service",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Transmission fluid service",
              },
            },
          ],
        },
      ],
    },
  };
}

export default function LocalBusinessJsonLd() {
  const jsonLd = buildLocalBusinessJsonLd();
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
}
